import { Column } from "@/components";

import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";
import { CandidateCommsTabs } from "./comms/CandidateCommsTabs";
import { CommsPanelCollapseHeader } from "./comms/CommsPanelCollapseHeader";
import { useCommsCandidacy } from "./comms/useCommsCandidacy";

// Candidate messages and emails with no way to send either. Shared by the
// search sheet and the application review portal — neither surface should be
// able to reach out to a candidate.
export const ReadOnlyCommsPanel = ({
  isMessagesOnly = false,
}: {
  isMessagesOnly?: boolean;
}) => {
  /* Database CRUD Operations */
  // Read — undefined on non-candidacy sheets (search); the tabs then scope
  // the thread to the sheet's own worker.
  const candidacy = useCommsCandidacy();
  const isMobile = useIsMobile();

  /* Render */
  const render = () => {
    return (
      <Column
        className={cn(
          "min-h-0 min-w-0 flex-1 self-stretch overflow-hidden border-transparent bg-blue-100/70 px-4 pb-4 pt-0",
          isMobile
            ? "m-0 rounded-none border-0"
            : "mx-4 mb-4 mt-0 rounded-xl border",
        )}
      >
        <CommsPanelCollapseHeader />
        <Column className="-mx-2 min-h-0 min-w-0 flex-1">
          <CandidateCommsTabs
            candidacy={candidacy}
            isMessagesOnly={isMessagesOnly}
            isReadOnly
            showMobileClose
          />
        </Column>
      </Column>
    );
  };

  return render();
};
